import { useMemo } from "react";
import { useSdk } from "../../contexts/services/hooks/use-services-context";
import type {
    AttachmentPreviewRef,
    MailViewContent,
} from "../../managers/mail/types/mail";

export type MailAttachments = {
    getAttachmentPreview: (ref: AttachmentPreviewRef) => Promise<string | null>;
    getMailViewContentFromRecord: (
        internetMessageIds: string[],
    ) => readonly MailViewContent[];
    fetchMissingMailViewContentIfAny: (
        internetMessageIds: string[],
    ) => Promise<void>;
};

export function useMailAttachments(): MailAttachments {
    const { mailManager } = useSdk();

    return useMemo<MailAttachments>(
        () => ({
            getAttachmentPreview: (...args) =>
                mailManager.getAttachmentPreview(...args),
            getMailViewContentFromRecord: (...args) =>
                mailManager.getMailViewContentFromRecord(...args),
            fetchMissingMailViewContentIfAny: (...args) =>
                mailManager.fetchMissingMailViewContentIfAny(...args),
        }),
        [mailManager],
    );
}
